export const DIAS_ACAMP = [
  { value: 'QUI', label: 'Quinta', short: 'Q' },
  { value: 'SEX', label: 'Sexta', short: 'S' },
  { value: 'SAB', label: 'Sábado', short: 'S' },
  { value: 'DOM', label: 'Domingo', short: 'D' }
]

const ORDER = { QUI: 0, SEX: 1, SAB: 2, DOM: 3 }
const VALUES = DIAS_ACAMP.map(d => d.value)

export function isDiaria(acampante) {
  const arr = acampante?.diasAcamp
  return Array.isArray(arr) && arr.length > 0
}

export function getDia(value) {
  return DIAS_ACAMP.find(d => d.value === value) || null
}

export function diasLabel(value) {
  return getDia(value)?.label || null
}

export function diasShort(value) {
  return getDia(value)?.short || null
}

export function sortDias(arr) {
  return [...(arr || [])]
    .filter(v => VALUES.includes(v))
    .sort((a, b) => ORDER[a] - ORDER[b])
}

// "Q · S · D"
export function diasShortChips(arr) {
  return sortDias(arr).map(diasShort).join(' · ')
}

// ["Quinta", "Sexta"]
export function diasLongChips(arr) {
  return sortDias(arr).map(diasLabel)
}

// "Qui, Sex"
export function diasInline(arr) {
  return sortDias(arr).map(v => diasLabel(v)?.slice(0, 3)).join(', ')
}
